module.exports = __webpack_public_path__ + "static/media/(V)-Prata-04.4fc81528.jpg";